import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TrTrackingChartComponent } from './tr-tracking-chart.component';

@NgModule({
    imports: [ CommonModule ],
    exports: [ TrTrackingChartComponent ],
    declarations: [ TrTrackingChartComponent ],
})
export class TrTrackingChartModule {}
